export const CANCELABLE_REQUEST_METHODS = ['POST', 'PUT', 'DELETE'];
